import { PropertyBase } from './property.base';

export class NonResidentialProperty extends PropertyBase {
  constructor(data?: any) {
    super(data);
  }
}
